"use client"

import * as React from "react"
import { Typography, Box, Stack } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { selectSelectedInventoryId } from "@src/store/selectors/behavior"

const ProductInStore = ({ detail }) => {
  const { t } = useTranslation()
  const selectedInventoryId = useSelector(selectSelectedInventoryId)
  const branchStocks = React.useMemo(() => {
    const currentInventory = detail?.inventories?.find(
      inventory => inventory.id === selectedInventoryId
    )

    return (
      currentInventory?.branch_stocks?.sort?.(
        (a, b) => b.number_of_stock - a.number_of_stock
      ) || []
    )
  }, [detail?.inventories, selectedInventoryId])

  if (!branchStocks.length) {
    return null
  }

  return (
    <Box id="branch_stock">
      <Typography
        variant="h1"
        component="h3"
        textAlign="center"
        sx={{
          fontWeight: 700,
          fontSize: {
            xs: 18,
            md: 40
          },
          marginY: {
            xs: "14px",
            md: "32px"
          }
        }}
      >
        {t("the_ciu_store")}
      </Typography>
      {branchStocks.map(branch => {
        let currentColor = "#87BD5E"
        let currentLabel = t("in_stock")

        if (branch.number_of_stock <= 0) {
          currentColor = "#7D7D7D"
          currentLabel = t("out_of_stock")
        }

        if (branch.number_of_stock === 1) {
          currentColor = "#FF0000"
          currentLabel = t("running_low")
        }

        return (
          <Stack
            py={{
              xs: "16px",
              md: "32px"
            }}
            justifyContent="space-between"
            alignItems="center"
            sx={{
              borderTop: "1px solid #7D7D7D"
            }}
          >
            <Typography
              variant="h4"
              component="h4"
              fontSize={{
                xs: "14px",
                md: "25px"
              }}
              color={branch.number_of_stock <= 0 ? "#7D7D7D" : "#000000"}
            >
              {branch.branch_name}
            </Typography>
            <Box
              sx={{
                borderRadius: "32px",
                border: `1px solid ${currentColor}`,
                padding: {
                  xs: "6px 12px",
                  md: "12px 20px"
                },
                fontSize: {
                  xs: "12px",
                  md: "21px"
                },
                color: currentColor,
                fontWeight: 600
              }}
            >
              {currentLabel}
            </Box>
          </Stack>
        )
      })}
    </Box>
  )
}

export default ProductInStore
